import type { ComponentProps } from 'react';
import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { scoutingCenter } from '@sorare/core/src/lib/glossary';

export type ProjectionGrade =
  | typeof So5FixtureEvent.CLASSIC
  | typeof So5FixtureEvent.DAILY;

const tooltipMessages: Record<ProjectionGrade, MessageDescriptor> = {
  [So5FixtureEvent.DAILY]: scoutingCenter.projectionGradeDailyTooltip,
  [So5FixtureEvent.CLASSIC]: scoutingCenter.projectionGradeClassicTooltip,
};

type Props = {
  mode: ProjectionGrade;
  color?: ComponentProps<typeof LabelS>['color'];
};

export const ProjectionGradeLabel = ({ mode }: Props) => {
  return (
    <Tooltip
      title={
        <LabelS className="text-center">
          <FormattedMessage {...tooltipMessages[mode]} />
        </LabelS>
      }
    >
      <LabelS className="text-center">
        <FormattedMessage {...scoutingCenter.projectionGrade} />
      </LabelS>
    </Tooltip>
  );
};
